import React from 'react';
import { SuccessPage } from '../../../../../components/SuccessPage/SuccessPage';

export const RefereeFormSuccessful: React.FC = () => {
  return (
    <div style={{ padding: '4rem' }}>
      <SuccessPage
        icon="succeed"
        title="Referee Form Submitted Successfully"
        message="Your referee form has been submitted successfully. "
        action={<a href="https://www.polyu.edu.hk">Exit the System</a>}
      />
    </div>
  );
};
